import { faX } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";

interface Props {
    value: string;
    onClose: () => void;
    onChange: (value: string) => void;
    onSubmit: () => void;
}

export default class VendorItemDashboardCreateVendorModalWidget extends React.Component<Props> {
    render(): React.ReactNode {
        return (
            // Dark BG
            <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 max-h-screen p-2">
                {/* The Modal */}
                <div className="relative bg-white rounded-lg shadow-lg mt-10 p-5 w-full max-w-4xl max-h-[83vh] overflow-y-auto">
                    <button
                        className="text-red-500 absolute right-3 top-3"
                        onClick={() => this.props.onClose()}
                    >
                        <FontAwesomeIcon icon={faX} />
                    </button>

                    <div className="mt-5"></div>
                    <label
                        className="block text-gray-700 text-sm font-bold mb-2"
                        htmlFor="vendorName"
                    >
                        Nama Vendor
                    </label>
                    <input
                        type="text"
                        id="vendorName"
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                        onChange={(e) => this.props.onChange(e.target.value)}
                    />
                    <button
                        className="mt-4 bg-blue-500 hover:bg-blue-700 disabled:bg-gray-300 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                        type="button"
                        onClick={() => this.props.onSubmit()}
                        disabled={this.props.value.length === 0}
                    >
                        Save
                    </button>
                </div>
            </div>
        );
    }
}
